import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgUserCircleIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M32 9.6C19.63 9.6 9.6 19.629 9.6 32c0 7.815 4.002 14.698 10.074 18.707l1.865-7.46a6.4 6.4 0 0 1 6.21-4.847h8.504a6.4 6.4 0 0 1 6.209 4.848l1.864 7.459C50.399 46.697 54.4 39.815 54.4 32 54.4 19.629 44.372 9.6 32 9.6m9.432 42.724-2.075-8.3a3.2 3.2 0 0 0-3.104-2.424h-8.505a3.2 3.2 0 0 0-3.104 2.424l-2.075 8.3A22.3 22.3 0 0 0 32 54.4c3.373 0 6.567-.744 9.432-2.076M6.4 32C6.4 17.862 17.862 6.4 32 6.4S57.6 17.862 57.6 32c0 9.785-5.49 18.285-13.55 22.592A25.5 25.5 0 0 1 32 57.6a25.5 25.5 0 0 1-12.049-3.008C11.891 50.285 6.401 41.785 6.401 32m19.2-9.6a3.2 3.2 0 0 1 3.2-3.2h6.4a3.2 3.2 0 0 1 3.2 3.2v8a3.2 3.2 0 0 1-3.2 3.2h-6.4a3.2 3.2 0 0 1-3.2-3.2zm3.2 0v8h6.4v-8z"
    />
  </svg>
)
export default SvgUserCircleIcon
